<template>
    <!-- 新增或修改表单开始 -->
    <div class="products-add-or-update">
        <el-dialog
            :title="products.id == 0 ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            @closed="dialogClose"
        >
            <el-form
                ref="products"
                :model="products"
                :rules="newsRules"
                label-width="80px"
                @keyup.enter.native="productsSubmit()"
            >
                <el-form-item label="商品名称" prop="productName">
                    <el-input v-model="products.productName"></el-input>
                </el-form-item>
                <el-form-item label="商品标题">
                    <el-input v-model="products.title"></el-input>
                </el-form-item>

                <el-row>
                    <el-col :span="12"
                        ><el-form-item label="产地">
                            <el-input
                                v-model="products.origin"
                            ></el-input> </el-form-item
                    ></el-col>
                    <el-col :span="12">
                        <el-form-item label="商品编号" prop="productNumber">
                            <el-input
                                v-model="products.productNumber"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"
                        ><el-form-item label="净含量">
                            <el-input
                                v-model.number="products.netWeight"
                            ></el-input> </el-form-item
                    ></el-col>
                    <el-col :span="12">
                        <el-form-item label="包装">
                            <el-input v-model="products.pack"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="商品等级">
                            <el-input
                                v-model.number="products.grade"
                            ></el-input> </el-form-item
                    ></el-col>
                    <el-col :span="12">
                        <el-form-item label="商品毛重">
                            <el-input
                                v-model.number="products.grossWeight"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"
                        ><el-form-item label="商品类型">
                            <el-select
                                v-model="products.productType"
                                clearable
                                placeholder="商品分类"
                            >
                                <el-option
                                    v-for="item in categories"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select> </el-form-item
                    ></el-col>
                    <el-col :span="12"
                        ><el-form-item label="商品价格">
                            <el-input-number
                                v-model="products.price"
                                controls-position="right"
                                :min="0"
                                size="small"
                            ></el-input-number> </el-form-item
                    ></el-col>
                    <el-col :span="12">
                        <el-form-item label="十佳产品">
                                <el-radio v-model="products.topTen" label="1">是</el-radio>
                                <el-radio v-model="products.topTen" label="0">否</el-radio>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12"
                        ><el-form-item label="年份" prop="year">
                            <el-date-picker
                                v-model="products.year"
                                type="year"
                                value-format="yyyy"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker></el-form-item
                    ></el-col>
                    <el-col :span="12">
                        <el-form-item label="商品内容" prop="content">
                            <el-button
                                type="info"
                                icon="el-icon-edit"
                                size="small"
                                @click="openRichDialog"
                                >前往编写商品内容</el-button
                            >
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="12">
                    <el-form-item label="产品图片">
                        <el-upload
                            class="upload"
                            ref="upload"
                            :action="uploadUrl"
                            name="file"
                            :limit="1"
                            accept=".png,.jpg"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-upload="beforeUpload"
                            :on-success="handleSuccess"
                            :file-list="fileList"
                            list-type="picture"
                        >
                            <el-button slot="trigger" size="small" type="primary"
                                >选取文件</el-button
                            >
                            <div slot="tip" class="el-upload__tip">
                                只能上传 .png .jpg图片，且不超过10MB
                            </div>
                    </el-upload>
                </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="店铺链接">
                            <el-input v-model="products.imagesUrl"  placeholder="请输入店铺链接"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" @click="productsSubmit"
                        >保存修改</el-button
                    >
                    <el-button @click="visible = false">取消</el-button>
                </el-form-item>
            </el-form>
            <!-- 内层对话框 -->
            <el-dialog
                width="50%"
                title="活动内容"
                :visible.sync="innerVisible"
                append-to-body
            >
                <div id="demo1"></div>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="innerVisible = false"
                        >确 定</el-button
                    >
                </span>
            </el-dialog>
        </el-dialog>
    </div>
    <!-- 新增或修改表单结束 -->
</template>

<script>
// 引入 wangEditor
import wangEditor from "wangeditor";
// 引入过滤函数
import { showcontent } from "@/utils/method.js";
export default {
    components: {
        // Editor
    },

    data() {
        return {
            visible: false,
            // 内层对话框的显示与隐藏
            innerVisible: false,
            products: {
                price: 0,
                imagesUrl:'',
                productName:'',
                productNumber:'',
                year:'',
                content:''
            },
            uploadUrl: "",
            fileList: [],
            // 商品类型
            categories: [
                { id: "1", name: "普通商品" },
                { id: "2", name: "好网货" },
                { id: "3", name: "皖货严选" },
            ],
            editor: null,
            // 限定时间选择器的时间范围
            pickerOptions: {
                disabledDate: (time) => {
                    return time.getFullYear() < 2018 || time.getFullYear() > (new Date()).getFullYear()
                }
            },
             newsRules:{
                productName:[
                    { required: true, message: '商品名称不能为空', trigger: 'blur' }
                ],
                 productNumber:[
                    { required: true, message: '商品编号不能为空', trigger: 'blur' }
                ],
                 year:[
                    { required: true, message: '年份不能为空', trigger: 'blur' }
                ],
                 content:[
                    { required: true, message: '商品内容不能为空', trigger: 'blur' }
                ]
            }
        };
    },

    activated() {
        this.getCategories();
    },
    methods: {
        init(id) {
            this.products.id = id || 0;
            this.visible = true;
            this.getCategories();
            this.$nextTick(() => {
                this.$refs["products"].resetFields();
                this.uploadUrl = 'https://activity.suhoo.net/api/upload/image';
                if (this.products.id) {
                    this.$http({
                        url: this.$http.adornUrl(
                            `/products/info/open/${this.products.id}`
                        ),
                        method: "get",
                        params: this.$http.adornParams(),
                    }).then(({ data }) => {
                        if (data && data.code === 0) {
                            this.products = data.data;
                            this.products.productName = showcontent(showcontent(
                                this.products.productName
                            ));
                            this.products.title = showcontent(showcontent(
                                this.products.title
                            ));
                            if (this.products.images) {
                                const obj = {
                                    url: this.products.images,
                                };
                                this.fileList = [obj];
                            }
                        }
                    });
                }
            });
        },

        // 提交数据
        productsSubmit() {
            let that = this
            // 更新商品的数据
            that.$refs.products.validate((valid) => {
                if (valid) {
            let products = { ...that.products };
            console.log(products)
            if (products.id === 0) {
                delete products.id;
            }
            //    if (products.productName == '' ||products.productNumber ==''  ) {
            //     return
            // }
            //products.checkStatus = "1";
            that.$http({
                url: that.$http.adornUrl(
                    `/products/${that.products.id == 0 ? "save" : "update"}`
                ),
                method: "post",
                data: that.$http.adornData(products, false),
            }).then(({ data }) => {
                console.log("保存商品：", data);
                if (data.code === 0) {
                    that.products = {};
                    that.visible = false;
                    that.$emit("updateList");
                    that.$message.success('保存成功')
                }
            });
             } else {
                    return false;
                }
            });
        },

        // 获取产品信息
        getCategories() {
            this.$http({
                url: this.$http.adornUrl("/category/list/EC000103"),
                method: "get",
            }).then(({ data }) => {
                console.log("产品信息：", data.data);
                //this.categories = data.data;
            });
        },
        // 添加活动内容富文本
        openRichDialog() {
            this.innerVisible = true;
            if (!this.editor) {
                this.$nextTick(() => {
                    // 创建富文本编辑器实例
                    const editor = new wangEditor("#demo1");
                    // 配置 onchange 回调函数，将数据同步到 vue 中
                    editor.config.onchange = (newHtml) => {
                        this.products.content = newHtml;
                    };
                    editor.config.uploadImgServer = this.uploadUrl;
                    editor.config.showLinkImg = false;
                    editor.config.uploadFileName = "file";
                    /* editor.config.customUploadImg = function (
                        resultFiles,
                        insertImgFn
                    ) {
                        let objectURL = URL.createObjectURL(resultFiles[0]);
                        insertImgFn(objectURL);
                        let reader = new FileReader();
                            reader.readAsDataURL(resultFiles[0]);
                            reader.onload = function (e) {
                                insertImgFn(e.target.result)
                            }
                    }; */
                    editor.config.uploadImgHooks = {
                        customInsert: function (insertImg, result, editor) {
                        let url = result.data
                        insertImg(url)
                        }
                    }
                    // 创建编辑器
                    editor.create();
                    if (this.products.content !== "") {
                        editor.txt.html(showcontent(showcontent(this.products.content)));
                    }
                    this.editor = editor;
                });
            }
        },

        // ================================================文件上传相关方法=======================================

        // 从本地保存的上传目录中删除图片路径
        handleRemove() {
            this.products.images = "";
        },
        handlePreview(file) {
            window.open(file.url, "_blank").location;
        },
        beforeUpload(file) {
            const isLt100M = file.size / 1024 / 1024 < 10;
            if (!isLt100M) {
                this.$message.error("上传文件大小不能超过 10MB!");
            }
            return isLt100M;
        },
        handleSuccess(response) {
            if (response && response.code === 0) {
				let url = (response.data.fileInfo.domain ? response.data.fileInfo.domain+'/' : 'https://activity.suhoo.net/')+response.data.fileInfo.file_path;
                this.products.images = url;
            }
        },
        // 对话框关闭的时候对表单进行重置
        dialogClose() {
            this.fileList = [];
            this.products = {};
            if (this.editor) {
                this.editor.destroy();
                this.editor = null;
            }
        },
    },
};
</script>
<style lang="less" scoped>
/deep/ .el-upload-list--picture {
    .el-upload-list__item {
        width: 92px;
        height: 92px;
    }
}
</style>
